export default {
    CheckPermissionForRecipients: {
        datapoint: {
            name: 'CheckPermissionForRecipients',
            customData: (atLeastOneRecipientCanNotAccess: boolean, linkCount: number) => [
                atLeastOneRecipientCanNotAccess,
                linkCount,
            ],
        },
    },
    CheckRecipientPermissionFailure: {
        datapoint: {
            name: 'CheckRecipientPermissionFailure',
            customData: (error: string) => [null],
        },
    },
};
